import { render, staticRenderFns } from "./PosterResult.vue?vue&type=template&id=3c137378&scoped=true&"
import script from "./PosterResult.vue?vue&type=script&lang=js&"
export * from "./PosterResult.vue?vue&type=script&lang=js&"
import style0 from "./PosterResult.vue?vue&type=style&index=0&id=3c137378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c137378",
  null
  
)

export default component.exports